{
  "deals": {
    "common": {
      "cancel": "Huỷ",
      "close": "Đóng",
      "save": "Lưu",
      "saving": "Đang lưu…",
      "systemError": "Lỗi hệ thống. Vui lòng thử lại sau.",
      "systemActor": "hệ thống",
      "notAssigned": "chưa gán"
    },
    "page": {
      "heading": "Deal"
    },
    "view": {
      "kanban": "Kanban",
      "list": "Danh sách"
    },
    "actions": {
      "newDeal": "Tạo deal",
      "addProducts": "+ Thêm sản phẩm",
      "editProducts": "Sửa sản phẩm",
      "pick": "Chọn",
      "createDeal": "Tạo deal"
    },
    "search": {
      "placeholder": "Tìm theo tên deal hoặc lead/merchant"
    },
    "filters": {
      "allStages": "Tất cả giai đoạn",
      "allSalers": "Tất cả seller"
    },
    "competitiveContextStub": "Bối cảnh cạnh tranh: trống (chờ P12)",
    "fallback": {
      "untitled": "(không có tiêu đề)",
      "saler": "Seller"
    },
    "pagination": {
      "summary": "Trang {{page}} / {{pageCount}} ({{total}} deal)",
      "prev": "Trước",
      "next": "Sau"
    },
    "columns": {
      "title": "Tên deal",
      "lead": "Lead / Merchant",
      "value": "Giá trị",
      "stage": "Giai đoạn",
      "owner_saler": "Seller",
      "expected_close_date": "Ngày chốt",
      "probability_pct": "Xác suất",
      "last_activity_at": "Hoạt động gần nhất"
    },
    "list": {
      "selectAllAria": "Chọn tất cả deal đang hiển thị",
      "selectRowAria": "Chọn deal {{title}}",
      "empty": "Không có deal nào khớp bộ lọc hiện tại."
    },
    "stages": {
      "draft": "Bản nháp",
      "pending_approval": "Chờ duyệt",
      "approved": "Đã duyệt",
      "sent": "Đã gửi",
      "won": "Thắng",
      "lost": "Mất",
      "expired": "Hết hạn",
      "rejected": "Từ chối",
      "declined": "Khách từ chối"
    },
    "kanbanColumns": {
      "draft": "Tìm kiếm",
      "pending_approval": "Đề xuất",
      "approved": "Đàm phán",
      "sent": "Đã gửi",
      "won": "Chốt thắng",
      "lost": "Chốt thua",
      "expired": "Hết hạn",
      "rejected": "Từ chối"
    },
    "kanban": {
      "closePrefix": "Chốt:",
      "daysInStage": "{{days}} ngày trong giai đoạn",
      "confirmStageTitle": "Xác nhận đổi giai đoạn",
      "confirmStageBody": "Chuyển {{title}} từ {{from}} sang {{to}}?",
      "confirmBtn": "Xác nhận",
      "configTooltip": "Cấu hình thẻ",
      "configTitle": "Cấu hình thẻ",
      "colorLabel": "Màu nền thẻ",
      "labelLabel": "Nhãn (gắn nhãn)",
      "labelPlaceholder": "VD: Ưu tiên, Nóng…",
      "colors": {
        "default": "Mặc định",
        "red": "Đỏ",
        "amber": "Vàng",
        "green": "Xanh lá",
        "blue": "Xanh dương",
        "purple": "Tím"
      }
    },
    "newModal": {
      "title": "Tạo deal",
      "titleLabel": "Tên deal",
      "titlePlaceholder": "VD: Báo giá nhân sự Q3 — Acme Corp",
      "leadLabel": "Lead",
      "leadPlaceholder": "Tìm lead theo tên / email / công ty…",
      "salerLabel": "Seller phụ trách",
      "salerPlaceholder": "Tìm seller theo tên / email…",
      "closeDateLabel": "Ngày dự kiến chốt",
      "templateLabel": "Mẫu",
      "templatePlaceholder": "(tuỳ chọn) tìm mẫu…",
      "notesLabel": "Ghi chú",
      "products": "Sản phẩm",
      "noProducts": "Chưa chọn sản phẩm nào — mở bộ chọn để gắn sản phẩm từ catalog.",
      "discountLabel": "Chiết khấu %",
      "taxLabel": "Thuế %",
      "grandTotal": "Tổng cộng"
    },
    "productPicker": {
      "title": "Thêm sản phẩm",
      "closeBackdropAria": "Đóng bộ chọn sản phẩm",
      "dialogAria": "Bộ chọn sản phẩm",
      "searchPlaceholder": "Tìm sản phẩm theo tên hoặc SKU",
      "searching": "Đang tìm…",
      "noMatch": "Không có sản phẩm phù hợp.",
      "startTyping": "Bắt đầu gõ để tìm trong catalog.",
      "add": "+ Thêm",
      "chooseVariant": "Chọn biến thể cho {{name}}",
      "noProductsPicked": "Chưa chọn sản phẩm nào.",
      "colProduct": "Sản phẩm",
      "colQty": "SL",
      "colUnitPrice": "Đơn giá",
      "colLineTotal": "Thành tiền",
      "skuPrefix": "SKU",
      "removeAria": "Xoá {{name}}",
      "subtotal": "Tạm tính:",
      "confirmOne": "Thêm {{count}} sản phẩm",
      "confirmMany": "Thêm {{count}} sản phẩm",
      "unknownError": "Lỗi không xác định"
    },
    "approval": {
      "title": "Duyệt deal {{id}}",
      "description": "Quy trình duyệt theo ngưỡng giá trị. Manager/Admin có quyền duyệt khi deal ở trạng thái “Chờ duyệt”.",
      "name": "Tên:",
      "grandTotal": "Tổng tiền:",
      "discount": "Chiết khấu:",
      "tax": "Thuế:",
      "saler": "Seller:",
      "requiredApprover": "Người duyệt yêu cầu:",
      "slaText": "Thời gian còn lại trước khi auto-escalate lên Admin:",
      "slaEscalated": " (đã chuyển Admin duyệt)",
      "submitHeading": "Gửi deal sang Manager/Admin duyệt",
      "submit": "Gửi duyệt",
      "submitting": "Đang gửi…",
      "commentLabel": "Ghi chú duyệt (tuỳ chọn — tối đa 500 ký tự)",
      "commentPlaceholder": "VD: OK ở mức chiết khấu này.",
      "approve": "Duyệt",
      "approving": "Đang duyệt…",
      "rejectLabel": "Lý do từ chối (5–1000 ký tự — bắt buộc)",
      "rejectPlaceholder": "VD: Margin quá thấp — vui lòng điều chỉnh chiết khấu.",
      "reject": "Từ chối",
      "rejecting": "Đang từ chối…",
      "reasonTooShort": "Vui lòng nhập lý do (tối thiểu 5 ký tự).",
      "toast": {
        "submitSuccessTitle": "Đã gửi yêu cầu duyệt",
        "submitSuccessDesc": "Deal {{id}} đang chờ Manager/Admin duyệt.",
        "submitErrorTitle": "Không gửi được yêu cầu",
        "approveSuccessTitle": "Đã duyệt deal",
        "approveSuccessDesc": "Deal {{id}} đã được phê duyệt.",
        "approveErrorTitle": "Không duyệt được",
        "rejectSuccessTitle": "Đã từ chối deal",
        "rejectSuccessDesc": "Deal {{id}} bị từ chối. Seller có thể gửi phiên bản mới.",
        "rejectErrorTitle": "Không từ chối được"
      },
      "disabledReason": {
        "notPending": "Deal đang ở trạng thái {{stage}}, không thể duyệt/từ chối.",
        "notApprover": "Chỉ Manager hoặc Admin mới có quyền duyệt deal.",
        "missingPermission": "Tài khoản của bạn chưa được cấp quyền crm:deals:approve.",
        "escalated": "Deal đã quá 48h — đã chuyển sang Admin duyệt."
      },
      "sla": {
        "overdue": "quá hạn",
        "minutes": "{{m}} phút",
        "hoursMinutes": "{{h}}h {{m}}p"
      }
    },
    "attachments": {
      "title": "Tệp đính kèm",
      "hint": ": tối đa 25MB/tệp, 100MB/deal. ClamAV quét sau khi tải lên.",
      "quotaWarning": "Đã dùng {{used}} / 100MB — gần đạt giới hạn deal.",
      "dropHint": "Kéo & thả tệp vào đây hoặc bấm nút chọn tệp.",
      "choose": "Chọn tệp",
      "uploading": "Đang tải…",
      "empty": "Chưa có tệp nào được đính kèm.",
      "download": "Tải về",
      "delete": "Xoá",
      "invalidFile": "Tệp không hợp lệ.",
      "scan": {
        "pending": "Đang quét…",
        "clean": "Sạch",
        "infected": "Nhiễm virus"
      },
      "toast": {
        "uploadedTitle": "Đã tải lên",
        "uploadedDesc": "{{filename}} đang được quét virus.",
        "uploadErrorTitle": "Tải lên thất bại",
        "deletedTitle": "Đã xoá tệp",
        "deletedDesc": "Tệp đính kèm đã được gỡ khỏi deal.",
        "deleteErrorTitle": "Không xoá được"
      },
      "error": {
        "empty": "Tệp rỗng.",
        "tooLarge": "Tệp vượt quá 25MB.",
        "mime": "Định dạng {{type}} không nằm trong whitelist (PDF/DOC/XLS/JPG/PNG/ZIP).",
        "totalExceeded": "Tổng dung lượng đính kèm của deal vượt quá 100MB."
      }
    },
    "send": {
      "title": "Gửi báo giá {{id}}",
      "description": "Soạn email và (tuỳ chọn) đính kèm PDF báo giá. Server sẽ tự DOMPurify body, ưu tiên Resend → SES fallback.",
      "toLabel": "Người nhận (To) — phân tách bằng dấu phẩy, 1–5 email",
      "toPlaceholder": "merchant@example.com",
      "ccLabel": "CC — tối đa 5 (để trống nếu không cần)",
      "ccPlaceholder": "cc1@example.com, cc2@example.com",
      "subjectLabel": "Tiêu đề email",
      "languageLabel": "Ngôn ngữ báo giá",
      "bodyLabel": "Nội dung email (HTML — sẽ được DOMPurify khi gửi)",
      "attachPdf": "Đính kèm PDF báo giá phiên bản hiện tại",
      "previewTitle": "Xem trước PDF",
      "generate": "Tạo bản PDF",
      "generating": "Đang tạo…",
      "previewPlaceholder": "Nhấn “Tạo bản PDF” để xem trước phiên bản hiện tại.",
      "iframeTitle": "Xem trước PDF",
      "send": "Gửi báo giá",
      "sending": "Đang gửi…",
      "invalidToList": "Danh sách email không hợp lệ.",
      "invalidCcList": "Danh sách CC không hợp lệ.",
      "languages": {
        "en": "English (EN)",
        "vi": "Tiếng Việt (VI)",
        "fr": "Français (FR)"
      },
      "toast": {
        "pdfSuccessTitle": "Đã tạo bản PDF",
        "pdfSuccessDesc": "Xem trước bên phải. Nhấn Gửi để chuyển cho khách.",
        "pdfErrorTitle": "Không tạo được PDF",
        "sentTitle": "Đã gửi báo giá",
        "sentDesc": "Gửi qua {{provider}} lúc {{time}}.",
        "sendErrorTitle": "Không gửi được báo giá"
      },
      "error": {
        "minEmails": "Cần ít nhất {{min}} email.",
        "maxEmails": "Tối đa {{max}} email.",
        "invalidEmail": "Email không hợp lệ: {{item}}"
      }
    },
    "compare": {
      "title": "So sánh phiên bản deal",
      "description": "Chọn hai phiên bản để xem chênh lệch dòng sản phẩm + chiết khấu + thuế + tổng.",
      "baseLabel": "Phiên bản gốc (trái)",
      "targetLabel": "Phiên bản so sánh (phải)",
      "versionOption": "v{{version}} — {{date}}",
      "needBoth": "Cần chọn cả hai phiên bản hợp lệ để xem khác biệt.",
      "identical": "Hai phiên bản này hoàn toàn giống nhau.",
      "summaryTitle": "Tóm tắt chênh lệch",
      "discount": "Chiết khấu",
      "tax": "Thuế",
      "grandTotal": "Tổng tiền",
      "productsTitle": "Chi tiết sản phẩm",
      "skuPrefix": "SKU:",
      "before": "Trước",
      "after": "Sau",
      "qtyPrefix": "SL",
      "none": "Không có",
      "status": {
        "added": "Mới thêm",
        "removed": "Đã bỏ",
        "changed": "Thay đổi",
        "unchanged": "Giữ nguyên"
      }
    },
    "detail": {
      "missingId": "Thiếu mã deal.",
      "loading": "Đang tải chi tiết deal…",
      "loadError": "Không tải được dữ liệu. Thử lại sau.",
      "back": "Quay lại danh sách deal",
      "tabsAria": "Các phần chi tiết deal",
      "tabs": {
        "overview": "Tổng quan",
        "versions": "Phiên bản",
        "activity": "Hoạt động",
        "documents": "Tài liệu"
      },
      "header": {
        "approvalPrefix": "Duyệt:",
        "lead": "Lead:",
        "saler": "Seller:",
        "generateSend": "Tạo & gửi báo giá",
        "sendEmail": "Gửi email",
        "approve": "Duyệt deal",
        "clone": "Nhân bản",
        "invalidateLink": "Vô hiệu link công khai"
      },
      "toast": {
        "cloneSuccessTitle": "Đã nhân bản deal",
        "cloneSuccessDesc": "Deal mới: {{id}}.",
        "cloneErrorTitle": "Không nhân bản được"
      },
      "overview": {
        "productsTitle": "Sản phẩm",
        "nonDraftNote": "Deal đã rời trạng thái Nháp — chỉ chỉnh sửa được qua tạo phiên bản mới (POST /versions).",
        "noProducts": "Chưa có sản phẩm nào trong deal.",
        "qty": "SL",
        "unitPrice": "Đơn giá",
        "lineTotal": "Thành tiền",
        "skuPrefix": "SKU",
        "summaryTitle": "Tổng kết",
        "subtotal": "Tạm tính",
        "discountPct": "Chiết khấu %",
        "taxPct": "Thuế %",
        "discountLine": "Chiết khấu (-)",
        "taxLine": "Thuế (+)",
        "grandTotal": "Tổng cộng",
        "expiryLabel": "Ngày dự kiến đóng (hết hạn)",
        "termsLabel": "Điều khoản",
        "notesLabel": "Ghi chú nội bộ",
        "save": "Lưu thay đổi",
        "saveSuccessTitle": "Đã lưu thay đổi",
        "saveSuccessDesc": "Deal {{id}} đã được cập nhật.",
        "saveErrorTitle": "Không lưu được deal"
      },
      "versions": {
        "title": "Phiên bản ({{count}})",
        "compare": "So sánh phiên bản",
        "tooMany": ": deal đã có {{count}} phiên bản — cân nhắc tạo deal mới thay vì tiếp tục chỉnh sửa.",
        "empty": "Deal chưa có phiên bản đã snapshot. Sẽ có khi “Tạo bản PDF” được chạy lần đầu.",
        "linkRevoked": "Link bị thu hồi {{date}}"
      },
      "activity": {
        "loading": "Đang tải hoạt động…",
        "loadError": "Không tải được hoạt động.",
        "title": "Hoạt động",
        "subtitle": "Log lọc theo deal hiện tại.",
        "empty": "Chưa có hoạt động nào được ghi nhận.",
        "actorPrefix": "Người thực hiện:"
      },
      "documents": {
        "pdfTitle": "Báo giá PDF theo phiên bản",
        "pdfSubtitle": "Mỗi phiên bản đã snapshot có 1 PDF — link mở trong tab mới.",
        "pdfEmpty": "Chưa có phiên bản nào được snapshot.",
        "openPdf": "Mở PDF"
      },
      "conflict": {
        "title": "Deal đã bị thay đổi",
        "description": "Một người dùng khác vừa cập nhật deal này. Vui lòng tải lại để xem phiên bản mới nhất trước khi lưu.",
        "dismiss": "Bỏ qua",
        "reload": "Tải lại"
      },
      "invalidate": {
        "title": "Vô hiệu link công khai",
        "description": "Link UUID hiện tại sẽ trả về 410 Gone. Hệ thống sinh UUID mới và ghi nhận hoạt động.",
        "reasonLabel": "Lý do (tuỳ chọn — sẽ hiển thị trong activity log)",
        "reasonPlaceholder": "VD: link bị chuyển tiếp ngoài ý muốn",
        "successTitle": "Đã vô hiệu link cũ",
        "successDesc": "Link công khai mới: {{uuid}}",
        "processing": "Đang xử lý…",
        "confirm": "Vô hiệu link"
      }
    }
  },
  "quotationBlocks": {
    "header": {
      "primaryColor": "Màu chủ đạo"
    },
    "footer": {
      "validityPlaceholder": "Báo giá có hiệu lực đến {{deal.valid_until}} · Phát hành bởi {{deal.seller.name}}"
    },
    "terms": {
      "defaultPlaceholder": "Thanh toán trong 15 ngày. Báo giá có hiệu lực trong 30 ngày. {{deal.notes}}"
    }
  },
  "leads": {
    "common": {
      "cancel": "Huỷ",
      "save": "Lưu",
      "saving": "Đang lưu…",
      "close": "Đóng",
      "loading": "Đang tải…",
      "actionSuccess": "Thao tác thành công.",
      "systemError": "Lỗi hệ thống. Vui lòng thử lại sau.",
      "loadError": "Không tải được dữ liệu. Thử lại sau.",
      "empty": "(trống)",
      "none": "—"
    },
    "stages": {
      "new": "Mới",
      "contacted": "Đã liên hệ",
      "qualified": "Đủ điều kiện",
      "negotiation": "Đang đàm phán",
      "converted": "Đã chuyển đổi",
      "lost": "Mất",
      "archived": "Lưu trữ"
    },
    "list": {
      "title": "Khách hàng tiềm năng",
      "viewKanban": "Kanban",
      "viewList": "Danh sách",
      "importCsv": "Nhập CSV",
      "newLead": "Lead mới",
      "searchPlaceholder": "Tìm theo tên / email / công ty",
      "allStages": "Tất cả giai đoạn",
      "allSalers": "Tất cả nhân viên sale",
      "pageInfo": "Trang {{page}} / {{pageCount}} ({{total}} lead)",
      "prev": "Trước",
      "next": "Sau"
    },
    "quickView": {
      "titleFallback": "Chi tiết lead",
      "email": "Email",
      "company": "Công ty",
      "stage": "Giai đoạn",
      "label": "Nhãn",
      "tags": "Tags",
      "notes": "Ghi chú",
      "notFound": "Không tìm thấy lead.",
      "openFull": "Mở trang chi tiết"
    },
    "table": {
      "colName": "Tên",
      "colEmail": "Email",
      "colCompany": "Công ty",
      "colStage": "Giai đoạn",
      "colSaler": "Nhân viên sale",
      "colTags": "Tags",
      "selectAll": "Chọn tất cả lead",
      "selectOne": "Chọn {{name}}",
      "empty": "Chưa có lead nào."
    },
    "kanban": {
      "confirmTitle": "Xác nhận đổi giai đoạn",
      "moveConfirm": "Chuyển \"{{name}}\" từ {{from}} sang {{to}}?",
      "confirm": "Xác nhận",
      "cardConfigTitle": "Cấu hình thẻ",
      "cardBg": "Màu nền thẻ",
      "cardLabel": "Nhãn (gắn nhãn)",
      "cardLabelPlaceholder": "VD: Ưu tiên, Nóng…",
      "colors": {
        "default": "Mặc định",
        "red": "Đỏ",
        "amber": "Vàng",
        "green": "Xanh lá",
        "blue": "Xanh dương",
        "purple": "Tím"
      }
    },
    "bulk": {
      "selected": "Đã chọn {{count}}",
      "reassign": "Gán lại",
      "changeStage": "Đổi giai đoạn",
      "delete": "Xoá",
      "exportCsv": "Xuất CSV",
      "clear": "Bỏ chọn",
      "confirmDelete": "Xoá {{count}} lead đã chọn?",
      "reassignTitle": "Gán lại {{count}} lead cho seller",
      "changeStageTitle": "Đổi giai đoạn {{count}} lead",
      "stagePlaceholder": "Chọn giai đoạn",
      "exportQueued": "Đang xuất CSV — bạn sẽ nhận được file khi hoàn tất.",
      "actionFailed": "Thao tác hàng loạt thất bại",
      "permissionHint": "Tài khoản của bạn chưa có quyền CRM cho thao tác này."
    },
    "csv": {
      "title": "Nhập lead từ CSV",
      "fields": {
        "name": "Tên *",
        "email": "Email chính *",
        "phone": "Số điện thoại",
        "company": "Công ty",
        "source": "Nguồn",
        "tags": "Tags"
      },
      "step1": "1. Tải lên",
      "step2": "2. Ghép cột",
      "step3": "3. Xem trước",
      "step4": "4. Tiến trình",
      "step5": "5. Báo cáo",
      "fileTooLarge": "Tệp vượt quá giới hạn 10MB.",
      "selected": "Đã chọn: {{name}}",
      "dropzone": "Kéo CSV vào đây hoặc bấm để chọn tệp",
      "uploadHint": "Tối đa 10MB / 5.000 dòng. Cột bắt buộc: Tên + Email chính.",
      "mappingHint": "Ghép cột CSV → trường Lead. Đã tự động nhận diện khi có thể.",
      "skip": "— bỏ qua —",
      "progressNote": "Đã đưa tác vụ nhập vào hàng đợi. Tiến trình sẽ cập nhật trực tiếp qua WebSocket.",
      "reportComplete": "Nhập hoàn tất.",
      "imported": "Đã nhập: {{count}}",
      "skipped": "Bỏ qua (email trùng): {{count}}",
      "errors": "Lỗi: {{count}}",
      "downloadErrorCsv": "Tải CSV lỗi",
      "next": "Tiếp",
      "startImport": "Bắt đầu nhập",
      "done": "Xong",
      "exportInProgress": "Đang xuất CSV — bạn sẽ nhận được file khi hoàn tất.",
      "parseFailed": "Không đọc được cột nào trong tệp này. Hãy lưu lại dạng CSV (phân tách bằng dấu phẩy, chấm phẩy hoặc tab) rồi thử lại — tệp .xlsx phải xuất sang CSV trước.",
      "notCsvFile": "Chỉ nhập được tệp .csv. Trong Excel chọn Tệp → Lưu thành → CSV."
    },
    "create": {
      "title": "Tạo Lead mới",
      "subtitle": "Nhập thông tin lead. Email phải là duy nhất.",
      "name": "Tên *",
      "emailPrimary": "Email chính *",
      "company": "Công ty",
      "source": "Nguồn",
      "notes": "Ghi chú",
      "sources": {
        "manual": "Nhập thủ công",
        "csv_import": "Nhập CSV",
        "auto_registration": "Tự đăng ký",
        "referral": "Giới thiệu"
      },
      "creating": "Đang tạo...",
      "submit": "Tạo lead",
      "errRequired": "Tên và email là bắt buộc",
      "errFail": "Tạo lead thất bại"
    },
    "activity": {
      "types": {
        "stage_change": "Đổi giai đoạn (stage change)",
        "note": "Ghi chú",
        "call": "Cuộc gọi",
        "meeting": "Cuộc họp",
        "email_sent": "Đã gửi email",
        "email_clicked": "Click email",
        "version": "Phiên bản báo giá",
        "approval": "Duyệt báo giá",
        "contacted": "Đã liên hệ",
        "attachment": "Tệp đính kèm",
        "quotation_sent": "Đã gửi báo giá"
      },
      "regionAria": "Dòng thời gian hoạt động của lead",
      "filterLabel": "Lọc theo loại sự kiện:",
      "clearFilter": "Bỏ lọc",
      "loading": "Đang tải hoạt động…",
      "empty": "Chưa có hoạt động nào.",
      "by": "Bởi: {{actor}}",
      "loadMore": "Xem thêm ({{count}})",
      "subject": "Tiêu đề: {{subject}}",
      "manualTypes": {
        "note": "Ghi chú",
        "call": "Cuộc gọi",
        "meeting": "Cuộc họp"
      },
      "formType": "Loại hoạt động",
      "duration": "Thời lượng (phút)",
      "body": "Nội dung",
      "bodyPlaceholder": "Tóm tắt buổi gọi/họp hoặc ghi chú nội bộ…",
      "followup": "Theo dõi tiếp (follow-up)",
      "repeat": "Lặp lại",
      "occurrences": "Lịch lặp tiếp theo:",
      "saveActivity": "Lưu hoạt động",
      "errBodyRequired": "Vui lòng nhập nội dung (body) trước khi lưu.",
      "savedTitle": "Thao tác thành công.",
      "savedDesc": "Đã ghi nhận hoạt động mới vào timeline.",
      "saveFailTitle": "Không lưu được hoạt động",
      "rrulePresets": {
        "none": "Không lặp lại",
        "daily": "Hằng ngày",
        "weekly": "Hằng tuần",
        "biweekly": "Hai tuần một lần",
        "monthly": "Hằng tháng"
      }
    },
    "merge": {
      "title": "Gộp lead trùng (merge duplicate)",
      "description": "Lead hiện tại sẽ được lưu trữ (soft-deleted) và toàn bộ hoạt động / deal / ghi chú sẽ được chuyển sang lead đích. Email chính của lead đích được giữ nguyên.",
      "fields": {
        "name": "Tên",
        "company": "Công ty",
        "phones": "Số điện thoại",
        "tags": "Tags",
        "notes": "Ghi chú",
        "custom_fields": "Trường tuỳ chỉnh"
      },
      "targetIdLabel": "ID lead đích (sẽ giữ lại)",
      "targetIdPlaceholder": "lead_xxx hoặc friendly_id",
      "loadTarget": "Tải dữ liệu",
      "sameLeadError": "Không thể gộp một lead với chính nó.",
      "loadingTarget": "Đang tải lead đích…",
      "targetNotFound": "Không tìm thấy lead đích.",
      "sourceCard": "Lead nguồn (sẽ lưu trữ)",
      "targetCard": "Lead đích (sẽ giữ lại)",
      "noConflict": "Không có xung đột trường — sẽ gộp toàn bộ hoạt động / deal / ghi chú vào lead đích, giữ nguyên các trường hiện có.",
      "conflictHint": "Các trường xung đột — chọn bên giữ lại:",
      "fieldPickerAria": "Bộ chọn trường",
      "colField": "Trường",
      "colSource": "Lead nguồn",
      "colTarget": "Lead đích",
      "confirm": "Xác nhận gộp lead",
      "merging": "Đang gộp…",
      "selectTargetFirst": "Vui lòng chọn lead đích trước.",
      "mergedDesc": "Đã gộp lead {{source}} vào {{target}}."
    },
    "detail": {
      "missingId": "Thiếu mã lead.",
      "loading": "Đang tải chi tiết lead…",
      "back": "Quay lại danh sách lead",
      "tabs": {
        "info": "Thông tin",
        "activity": "Hoạt động",
        "deals": "Deals",
        "merchant": "Merchant",
        "files": "Files"
      },
      "tabsAria": "Các phần chi tiết lead",
      "company": "Công ty: {{company}}",
      "email": "Email: {{email}}",
      "phone": "SĐT: {{phones}}",
      "assignee": "Phụ trách:",
      "unassigned": "Chưa gán",
      "convertBtn": "Chuyển thành merchant",
      "convertedBtn": "Đã chuyển đổi",
      "mergeBtn": "Gộp lead trùng",
      "archiveBtn": "Lưu trữ",
      "archivedBtn": "Đã lưu trữ",
      "basicInfo": "Thông tin cơ bản",
      "customFields": "Custom fields",
      "customFieldsHint": "Soạn dưới dạng JSON object. Server xác thực schema.",
      "fieldName": "Tên",
      "fieldStage": "Giai đoạn",
      "fieldAssignee": "Phụ trách",
      "assigneePlaceholder": "Tìm seller theo tên / email…",
      "fieldTags": "Tags (phân tách dấu phẩy)",
      "tagsPlaceholder": "vip, q2-priority",
      "fieldNotes": "Ghi chú nội bộ",
      "saveChanges": "Lưu thay đổi",
      "savedDesc": "Đã cập nhật lead {{id}}.",
      "saveFailTitle": "Không lưu được lead",
      "customFieldsInvalid": "custom_fields phải là JSON object.",
      "deals": {
        "loading": "Đang tải deals…",
        "empty": "Lead này chưa có deal nào liên kết.",
        "colDeal": "Deal",
        "colStage": "Stage",
        "colValue": "Giá trị",
        "colExpiry": "Hết hạn",
        "noTitle": "(không tiêu đề)"
      },
      "files": {
        "loading": "Đang tải tệp…",
        "empty": "Chưa có tệp nào. Tệp được đính kèm trên các deal liên kết với lead này.",
        "dealPrefix": "Deal: {{deal}}",
        "fileFallback": "tệp"
      },
      "merchant": {
        "notConvertedTitle": "Chưa chuyển đổi",
        "notConvertedDesc": "Lead này chưa được chuyển đổi sang merchant. Bấm nút 'Chuyển thành merchant' ở thanh hành động để bắt đầu quy trình onboarding.",
        "convertedTitle": "Merchant đã chuyển đổi",
        "convertedBody": "Lead này đã được chuyển đổi thành merchant",
        "openMerchant": "Mở trang merchant →"
      },
      "archive": {
        "title": "Lưu trữ lead",
        "description": "Lead {{id}} sẽ được lưu trữ (soft-delete). Bạn có thể khôi phục từ trang lưu trữ.",
        "archiving": "Đang lưu trữ…"
      },
      "convert": {
        "title": "Chuyển lead thành merchant",
        "descWithEmail": "Lead {{id}} sẽ được chuyển thành merchant. Một tài khoản đăng nhập sẽ được tạo và gửi email mời.",
        "descNoEmail": "Lead {{id}} sẽ được chuyển thành merchant. Một tài khoản đăng nhập sẽ được tạo (không gửi email).",
        "descIneligible": "Lead {{id}} đang ở giai đoạn {{stage}}. Chỉ chuyển đổi được khi giai đoạn là \"Đủ điều kiện\" hoặc \"Đàm phán\".",
        "sendEmail": "Gửi email mời đăng nhập cho merchant mới",
        "converting": "Đang chuyển…",
        "confirm": "Chuyển đổi",
        "eligibilityError": "Chỉ chuyển đổi được khi giai đoạn là \"Đủ điều kiện\" hoặc \"Đàm phán\".",
        "successTitle": "Đã chuyển đổi sang merchant",
        "successDesc": "Merchant {{id}} đã được tạo.",
        "archiveSuccessDesc": "Đã lưu trữ lead {{id}}."
      }
    }
  },
  "settings": {
    "page": {
      "heading": "Cấu hình Bán hàng",
      "description": "Cấu hình CRM cho toàn bộ pipeline bán hàng — ngưỡng phê duyệt, trường tùy chỉnh, lý do thất bại, mẫu báo giá, email tổng hợp cho Admin, tích hợp Lark / ICS.",
      "tablistAria": "Tab cấu hình bán hàng"
    },
    "tabs": {
      "general": "Chung",
      "customFields": "Trường tùy chỉnh",
      "lossReasons": "Lý do thất bại",
      "templates": "Mẫu báo giá",
      "digest": "Email tổng hợp",
      "integrations": "Tích hợp"
    },
    "common": {
      "save": "Lưu",
      "saving": "Đang lưu…",
      "undo": "Hoàn tác",
      "add": "+ Thêm",
      "adding": "Đang thêm…",
      "delete": "Xóa",
      "setDefault": "Đặt mặc định",
      "defaultBadge": "Mặc định",
      "saveFailed": "Không lưu được",
      "setDefaultSuccess": "Đã đặt mặc định",
      "setDefaultFailed": "Không đặt được mặc định",
      "label": "Nhãn",
      "enable": "Bật"
    },
    "general": {
      "validation": {
        "number": "Phải là số",
        "integer": "Phải là số nguyên",
        "nonNegative": "Không được âm",
        "tooLarge": "Quá lớn",
        "minDays": "Tối thiểu 1 ngày",
        "maxDays": "Tối đa 90 ngày"
      },
      "approval": {
        "title": "Ngưỡng phê duyệt",
        "description": "Các mức USD (cents) để báo giá tự động chuyển sang cấp phê duyệt tương ứng. Báo giá ≤ hạn mức Seller → tự động duyệt. Vượt hạn mức Seller → Manager. Vượt Manager → Admin.",
        "salerLimit": "Hạn mức Seller tự động duyệt (cents)",
        "managerLimit": "Hạn mức Manager (cents)",
        "adminLimit": "Hạn mức Admin (cents)"
      },
      "reminders": {
        "title": "Ngưỡng nhắc nhở & tồn đọng",
        "description": "Số ngày Lead không có hoạt động trước khi gửi nhắc nhở. Ngưỡng hết hạn deal và hội thoại tồn đọng đang cố định theo CONTEXT.",
        "leadInactive": "Nhắc Lead không hoạt động (ngày)"
      },
      "fixedInfo": {
        "dealExpiryLabel": "Nhắc deal hết hạn:",
        "dealExpiryBefore": "7 ngày trước ",
        "dealExpiryAfter": "(cố định,).",
        "staleLabel": "Ngưỡng hội thoại tồn đọng:",
        "staleValue": "3 ngày / 7 ngày / 14 ngày (cố định,)."
      },
      "saveSuccessTitle": "Đã lưu",
      "saveSuccessDesc": "Cấu hình Chung đã được cập nhật.",
      "loading": "Đang tải cấu hình Chung",
      "loadError": "Không thể tải cấu hình Chung."
    },
    "customFields": {
      "loading": "Đang tải trường tùy chỉnh",
      "loadError": "Không thể tải trường tùy chỉnh.",
      "addedSuccess": "Đã thêm trường tùy chỉnh",
      "addFailed": "Không thêm được",
      "reorderSuccess": "Đã cập nhật thứ tự",
      "reorderFailed": "Không lưu được thứ tự",
      "deletedSuccess": "Đã xóa trường tùy chỉnh",
      "deleteFailed": "Không xóa được",
      "listTitle": "Trường tùy chỉnh",
      "listDescription": "Quản lý trường tùy chỉnh cho Lead. Kéo-thả để đổi thứ tự (vị trí hiển thị trên form Lead).",
      "empty": "Chưa có trường tùy chỉnh nào.",
      "dragTitle": "Kéo để đổi thứ tự",
      "requiredBadge": "Bắt buộc",
      "addTitle": "Thêm trường tùy chỉnh",
      "addDescription": "Trường sẽ xuất hiện trên form Lead theo vị trí được phân bổ.",
      "labelPlaceholder": "VD: Ngành hàng",
      "typeLabel": "Loại",
      "requiredCheckbox": "Bắt buộc",
      "types": {
        "text": "Văn bản",
        "number": "Số",
        "dropdown": "Danh sách chọn",
        "date": "Ngày",
        "checkbox": "Ô đánh dấu"
      }
    },
    "digest": {
      "saveSuccess": "Đã lưu lịch Email tổng hợp",
      "loading": "Đang tải cấu hình Email tổng hợp",
      "loadError": "Không thể tải cấu hình Email tổng hợp.",
      "cardTitle": "Email tổng hợp cho Admin",
      "cardDescription": "Email tổng hợp gửi tới Admin với phễu bán hàng + điểm nhấn thắng/thua. Chọn tần suất, hoặc tắt hẳn nếu không cần.",
      "enableLabel": "Bật",
      "enableCheckbox": "Bật Email tổng hợp cho Admin",
      "cadenceLabel": "Tần suất",
      "cadence": {
        "dailyMorning": "Hằng ngày — 8:00 giờ máy chủ",
        "weeklyMonday": "Hằng tuần — sáng thứ Hai"
      }
    },
    "integrations": {
      "saveSuccess": "Đã lưu Tích hợp",
      "loading": "Đang tải Tích hợp",
      "loadError": "Không thể tải Tích hợp.",
      "validation": {
        "urlTooLong": "URL quá dài",
        "urlHttps": "Webhook URL phải bắt đầu bằng https://"
      },
      "missingWebhookTitle": "Thiếu webhook URL",
      "missingWebhookDesc": "Nhập webhook URL trước khi test.",
      "testSuccessTitle": "Lark webhook hoạt động",
      "testSuccessDesc": "Đã nhận phản hồi 2xx từ Lark.",
      "testFailedTitle": "Test Lark thất bại",
      "lark": {
        "title": "Lark Bot",
        "description": "Gửi thông báo CRM (lead mới, deal thắng, leo thang) tới nhóm Lark qua incoming webhook. Test trước khi bật.",
        "enableLabel": "Bật Lark Bot",
        "webhookLabel": "Webhook URL",
        "test": "Test webhook",
        "testing": "Đang gửi test…"
      },
      "ics": {
        "title": "Xuất lịch ICS",
        "description": "Khi bật, mỗi Seller nhận URL ICS feed (đăng ký theo URL) để kéo deal hết hạn + nhắc lead vào lịch Google / Outlook.",
        "enableLabel": "Bật ICS feed"
      }
    },
    "lossReasons": {
      "addedSuccess": "Đã thêm lý do thất bại",
      "addFailed": "Không thêm được",
      "reorderSuccess": "Đã cập nhật thứ tự",
      "reorderFailed": "Không lưu được thứ tự",
      "actionFailed": "Thao tác thất bại",
      "loading": "Đang tải lý do thất bại",
      "loadError": "Không thể tải lý do thất bại.",
      "listTitle": "Lý do thất bại",
      "listDescription": "Các lý do hiển thị trong danh sách chọn khi đóng Lead ở trạng thái Thất bại. Lý do mặc định (Ngân sách / Đối thủ / Không phản hồi / Không đủ điều kiện / Khác) không xóa được — chỉ lưu trữ.",
      "empty": "Chưa có lý do thất bại nào.",
      "defaultSeedBadge": "Mặc định",
      "archivedBadge": "Đã lưu trữ",
      "restore": "Khôi phục",
      "archive": "Lưu trữ",
      "addTitle": "Thêm lý do thất bại",
      "addDescription": "Lý do mới sẽ xuất hiện cuối danh sách; dùng kéo-thả để đổi vị trí sau khi tạo.",
      "labelPlaceholder": "VD: Giá quá cao"
    },
    "templates": {
      "deletedSuccess": "Đã xóa mẫu",
      "deleteFailed": "Không xóa được",
      "loading": "Đang tải mẫu báo giá",
      "loadError": "Không thể tải mẫu báo giá.",
      "title": "Mẫu báo giá",
      "description": "Trình chỉnh sửa khối cho từng mẫu ở trang riêng (task-55). Mỗi locale (EN/VI/FR) có thể có 1 mẫu mặc định; báo giá tạo từ Lead sẽ dùng mẫu mặc định theo locale của Merchant.",
      "newTemplate": "+ Mẫu mới",
      "empty": "Chưa có mẫu nào.",
      "deleteDefaultTooltip": "Đặt mẫu khác làm mặc định trước khi xóa."
    },
    "editor": {
      "saveSuccess": "Đã lưu mẫu",
      "saveFailed": "Không lưu được mẫu",
      "previewFailed": "Lỗi xem trước",
      "setDefaultSuccess": "Đã đặt mặc định",
      "setDefaultFailed": "Không đặt được mặc định",
      "loading": "Đang tải mẫu",
      "loadError": "Không thể tải mẫu.",
      "namePlaceholder": "Tên mẫu",
      "untitledTemplate": "Mẫu chưa đặt tên",
      "rendering": "Đang render…",
      "refreshPreview": "Làm mới xem trước",
      "setDefault": "Đặt mặc định",
      "saving": "Đang lưu…",
      "save": "Lưu mẫu",
      "productTableTitle": "Bảng sản phẩm",
      "productTableBody": "Hiển thị từ máy chủ dựa trên deal items: SKU · Tên · Đơn vị · Số lượng · Đơn giá · Thành tiền. Bố cục cố định.",
      "summaryTitle": "Tổng kết",
      "summaryTokensLabel": "Token tự động chèn:",
      "variablesTitle": "Biến",
      "variablesHelp": "Nhấn để copy token. Dán vào ô Điều khoản / Chân trang.",
      "copiedTitle": "Đã copy token",
      "pdfPreviewTitle": "Xem trước PDF",
      "pdfPreviewSubtitle": "Deal mẫu · tự động làm mới khi lưu",
      "iframeTitle": "Xem trước PDF báo giá",
      "previewEmpty": "Nhấn “Làm mới xem trước” để render PDF với deal mẫu.",
      "conflictTitle": "Mẫu đã bị thay đổi",
      "conflictBody": "Một admin khác vừa lưu mẫu này. Tải lại để xem snapshot mới và áp dụng lại thay đổi của bạn?",
      "close": "Đóng",
      "reload": "Tải lại",
      "tokenDesc": {
        "leadFullName": "Họ tên đầy đủ của Lead",
        "leadCompany": "Công ty của Lead",
        "dealId": "Mã deal",
        "dealValue": "Giá trị tiền của deal",
        "dealValidUntil": "Ngày hiệu lực của deal",
        "dealSalerName": "Họ tên Seller",
        "dealNotes": "Ghi chú riêng của deal",
        "productsTable": "Bảng sản phẩm tự động",
        "subtotal": "Tạm tính",
        "discount": "Số tiền giảm giá",
        "tax": "Số tiền thuế",
        "total": "Tổng cộng"
      }
    }
  },
  "benefits": {
    "page": {
      "title": "Quyền lợi Merchant",
      "description": "Cấp quyền lợi cho merchant đạt mốc GMV.",
      "salerReadonly": "Seller chỉ có quyền xem."
    },
    "tabs": {
      "pending": "Chờ duyệt",
      "granted": "Đã cấp"
    },
    "table": {
      "merchant": "Merchant",
      "tier": "Tier",
      "benefitType": "Loại quyền lợi",
      "description": "Mô tả",
      "status": "Trạng thái",
      "action": "Hành động"
    },
    "actions": {
      "grant": "Cấp"
    },
    "status": {
      "pending": "Chờ duyệt",
      "granted": "Đã cấp",
      "revoked": "Đã thu hồi"
    },
    "benefitTypes": {
      "pricing_tier": "Pricing tier (đổi tier giá)",
      "wallet_credit": "Wallet credit (nạp ví)",
      "badge": "Badge (huy hiệu)",
      "custom": "Custom (tuỳ chỉnh)"
    },
    "empty": {
      "pending": "Chưa có merchant nào chờ cấp quyền lợi.",
      "granted": "Chưa có quyền lợi nào được cấp."
    },
    "loading": "Đang tải dữ liệu…",
    "pagination": {
      "info": "Trang {{page}} / {{pageCount}} ({{total}} quyền lợi)",
      "prev": "Trước",
      "next": "Sau"
    },
    "toast": {
      "success": "Thao tác thành công."
    },
    "modal": {
      "title": "Cấp quyền lợi",
      "merchantLabel": "Merchant",
      "tierLabel": "Tier",
      "benefitTypeLabel": "Loại quyền lợi",
      "amountLabel": "Số tiền (cents)",
      "amountPlaceholder": "50000",
      "descriptionLabel": "Mô tả ({{count}}/500)",
      "descriptionPlaceholder": "Hoàn tiền Bronze tháng 4/2026",
      "expiresLabel": "Hết hạn (tuỳ chọn)",
      "cancel": "Huỷ",
      "submit": "Cấp",
      "submitting": "Đang xử lý…",
      "errors": {
        "description": "Mô tả cần từ 2 đến 500 ký tự.",
        "amount": "Wallet credit phải có số tiền (đơn vị: cents) ≥ 1.",
        "invalidDate": "Ngày hết hạn không hợp lệ."
      }
    }
  },
  "groups": {
    "page": {
      "title": "Nhóm Seller",
      "description": "Quản lý nhóm Seller / Manager — phân cấp 2 tầng."
    },
    "actions": {
      "create": "+ Tạo nhóm",
      "view": "Xem",
      "edit": "Sửa",
      "assignSaler": "Gán Seller",
      "addSubGroup": "+ Sub-group",
      "delete": "Xoá"
    },
    "common": {
      "cancel": "Huỷ"
    },
    "tree": {
      "empty": "Chưa có Seller Group nào. Bấm \"Tạo nhóm\" để bắt đầu.",
      "level": "Lv {{level}}",
      "memberCount": "{{count}} thành viên",
      "subGroupCount": "{{count}} sub-group",
      "deleteBlockedChildren": "Không thể xoá: nhóm còn sub-group bên dưới.",
      "deleteBlockedMembers": "Không thể xoá: nhóm còn {{count}} thành viên.",
      "deleteTitle": "Xoá nhóm"
    },
    "form": {
      "nameLabel": "Tên nhóm",
      "managerLabel": "Manager",
      "managerPlaceholder": "Tìm manager theo tên hoặc email…",
      "managerHint": "Để trống nếu chưa gán manager.",
      "subGroupHint": "Tạo sub-group (Level 2) bên dưới nhóm cha:",
      "submitting": "Đang lưu…",
      "create": "Tạo nhóm",
      "update": "Cập nhật",
      "error": "Đã xảy ra lỗi khi lưu nhóm."
    },
    "dialog": {
      "createTitle": "Tạo nhóm mới",
      "editTitle": "Sửa nhóm"
    },
    "confirm": {
      "delete": "Xoá nhóm \"{{name}}\"?",
      "removeMember": "Gỡ \"{{name}}\" khỏi nhóm \"{{group}}\"?"
    },
    "assign": {
      "title": "Gán Seller vào \"{{name}}\"",
      "description": "Tìm seller theo tên hoặc email.: leads cũ vẫn ở team cũ, cần reassign riêng.",
      "placeholder": "Tìm seller theo tên / email…",
      "submit": "Gán"
    },
    "members": {
      "title": "Thành viên — {{name}}",
      "countLevel": "{{count}} thành viên · Lv {{level}}",
      "close": "Đóng",
      "loading": "Đang tải…",
      "empty": "Nhóm chưa có thành viên nào.",
      "remove": "Gỡ"
    },
    "loading": "Đang tải dữ liệu…"
  },
  "merchants": {
    "list": {
      "title": "Merchants — Sức khỏe khách hàng",
      "subtitle": "Sắp xếp theo điểm sức khỏe tăng dần (nguy cấp lên đầu).",
      "searchPlaceholder": "Tìm merchant…",
      "healthFilterLabel": "Sức khỏe:",
      "tierFilterLabel": "Hạng KPI:",
      "loading": "Đang tải dữ liệu…",
      "empty": "Không có merchant nào khớp bộ lọc.",
      "selectRowAria": "Chọn {{name}}",
      "columns": {
        "merchant": "Merchant",
        "tier": "Hạng",
        "health": "Sức khỏe",
        "score": "Điểm",
        "lastOrder": "Đơn gần nhất"
      },
      "bulk": {
        "selectedCount": "Đã chọn {{count}} merchant",
        "clear": "Bỏ chọn",
        "grantBenefit": "Cấp benefit hàng loạt",
        "grantBenefitTooltip": "Cấp cùng một benefit cho nhiều merchant — xem flow chi tiết ở /admin/sales/benefits."
      }
    },
    "health": {
      "stateLabels": {
        "healthy": "Khỏe mạnh",
        "at_risk": "Có rủi ro",
        "critical": "Nguy cấp",
        "churned": "Đã rời bỏ"
      },
      "notComputedTooltip": "Điểm sức khỏe chưa được tính. Cron RFM chạy lúc 02:00 UTC mỗi đêm.",
      "breakdown": "Chi tiết: {{text}}",
      "weights": "Trọng số: R=40, F=30, M=20, E=10."
    },
    "tierLabels": {
      "bronze": "Đồng",
      "silver": "Bạc",
      "gold": "Vàng",
      "platinum": "Bạch kim"
    },
    "trendLabels": {
      "improving": "Đang cải thiện",
      "declining": "Đang giảm",
      "stable": "Ổn định"
    },
    "drawer": {
      "close": "Đóng",
      "healthScoreLabel": "Điểm sức khỏe:",
      "scoreComponents": "Thành phần điểm",
      "maxPoints": "tối đa {{weight}}đ",
      "detailNote": "Chi tiết điểm từng thành phần + lịch sử đơn hàng có trong hồ sơ đầy đủ.",
      "tier": "Hạng",
      "lastOrder": "Đơn gần nhất",
      "scoreUpdated": "Cập nhật điểm",
      "viewFullProfile": "Xem hồ sơ đầy đủ",
      "dimensions": {
        "R": "Recency (đơn gần nhất)",
        "F": "Frequency (tần suất đơn)",
        "M": "Monetary (GMV)",
        "E": "Engagement"
      }
    }
  },
  "reports": {
    "periods": {
      "week": "Tuần",
      "month": "Tháng",
      "quarter": "Quý",
      "year": "Năm"
    },
    "periodAria": "Chu kỳ",
    "stageLabels": {
      "new": "Mới",
      "qualified": "Đủ điều kiện",
      "proposal": "Đề xuất",
      "negotiation": "Đàm phán",
      "closed_won": "Chốt thắng",
      "closed_lost": "Chốt thua"
    },
    "filters": {
      "salerId": "Mã seller",
      "groupId": "Mã nhóm",
      "allPlaceholder": "(tất cả)"
    },
    "export": {
      "csv": "Export CSV",
      "excel": "Export Excel",
      "jobCreatedTitle": "Đã tạo job {{format}}",
      "jobCreatedDesc": "Email sẽ gửi khi hoàn tất (~{{seconds}}s).",
      "errorTitle": "Không tạo được export"
    },
    "funnel": {
      "title": "Lead Funnel",
      "subtitle": "Phân bố leads theo giai đoạn + tỷ lệ chuyển đổi giữa các bước.",
      "overallConversion": "Tỷ lệ chuyển đổi tổng",
      "stageCount": "Số giai đoạn",
      "distributionByStage": "Phân bố theo giai đoạn",
      "chartEmpty": "Chưa có dữ liệu funnel.",
      "tableEmpty": "Không có dữ liệu.",
      "columns": {
        "stage": "Giai đoạn",
        "count": "Số lượng",
        "conversionNext": "% chuyển đổi sang bước kế"
      }
    },
    "winLoss": {
      "title": "Win / Loss",
      "subtitle": "Deals chốt thắng vs chốt thua theo thời gian + win-rate + phân loại lý do thua.",
      "winRate": "Tỷ lệ thắng",
      "won": "Thắng",
      "lost": "Thua",
      "chartTitle": "Thắng vs Thua",
      "chartEmpty": "Chưa có dữ liệu.",
      "wonLabel": "Thắng",
      "lostLabel": "Thua",
      "lossReasonsTitle": "Lý do thua",
      "reasonsEmpty": "Không có deal thua trong khoảng này.",
      "columns": {
        "reason": "Lý do",
        "dealCount": "Số deal"
      }
    },
    "hub": {
      "title": "Sales Reports",
      "subtitle": "Báo cáo Funnel / Win-Loss / Pipeline / GMV. Click vào card để xem chi tiết.",
      "cardsAria": "Báo cáo",
      "pipelineSummaryAria": "Tổng quan pipeline",
      "activePipeline": "Pipeline đang hoạt động",
      "grandPipeline": "Tổng pipeline",
      "forecastWeighted": "Dự báo (có trọng số)",
      "chartEmpty": "Chưa có deal active."
    },
    "cards": {
      "funnel": {
        "label": "Lead Funnel",
        "description": "Phân bố lead theo giai đoạn + tỷ lệ chuyển đổi từng bước."
      },
      "win-loss": {
        "label": "Win / Loss",
        "description": "Deal chốt thắng vs chốt thua theo thời gian + win-rate."
      },
      "pipeline": {
        "label": "Pipeline",
        "description": "Tổng giá trị deal đang hoạt động theo giai đoạn + dự báo (có trọng số xác suất)."
      },
      "gmv": {
        "label": "GMV",
        "description": "GMV theo seller / merchant / category + xuất CSV."
      }
    }
  },
  "shared": {
    "autocomplete": {
      "placeholder": "Tìm theo tên / email…",
      "searching": "Đang tìm…",
      "noResults": "Không có kết quả"
    },
    "userChip": {
      "unassigned": "Chưa gán",
      "fallbackName": "Người dùng {{idTail}}"
    }
  },
  "calendar": {
    "title": "Lịch của tôi",
    "subtitle": "Follow-up + deal hết hạn + quotation đã gửi. Bấm \"Đổi giờ\" để lên lịch lại.",
    "newFollowup": "+ Tạo follow-up",
    "viewModeAria": "Chế độ xem",
    "gridAria": "Lưới",
    "loadError": "Không tải được lịch.",
    "noEvents": "Không có sự kiện",
    "cancel": "Huỷ",
    "views": {
      "week": "Tuần",
      "day": "Ngày"
    },
    "eventKinds": {
      "follow_up": "Follow-up",
      "deal_expire": "Deal hết hạn",
      "quotation_sent": "Quotation đã gửi"
    },
    "reschedule": {
      "title": "Đổi giờ",
      "dateTimeLabel": "Ngày và giờ mới",
      "saving": "Đang lưu…",
      "confirm": "Xác nhận"
    },
    "create": {
      "title": "Tạo follow-up",
      "description": "Tạo lead mới với mốc liên hệ — sẽ hiện trên lịch.",
      "nameLabel": "Tên *",
      "emailLabel": "Email *",
      "contactLabel": "Mốc liên hệ *",
      "creating": "Đang tạo…",
      "submit": "Tạo"
    },
    "toast": {
      "createSuccess": "Đã tạo follow-up",
      "createFailTitle": "Không tạo được",
      "rescheduleSuccessTitle": "Đã đổi giờ",
      "rescheduleSuccessDesc": "Sự kiện đã được lên lịch lại.",
      "rescheduleFailTitle": "Không đổi được",
      "invalidFormatTitle": "Định dạng sai",
      "invalidFormatDesc": "Vui lòng chọn ngày/giờ hợp lệ."
    },
    "regenerate": {
      "create": "Tạo URL ICS mới",
      "creating": "Đang tạo…",
      "copyUrl": "Copy URL",
      "overlapNote": "URL cũ tiếp tục hoạt động đến {{date}}.",
      "toast": {
        "createdTitle": "Đã tạo URL mới",
        "createdDesc": "URL cũ vẫn hoạt động trong 7 ngày để tránh gián đoạn.",
        "createFailTitle": "Không tạo được URL mới",
        "copiedTitle": "Đã copy",
        "copiedDesc": "URL ICS mới đã được copy.",
        "copyFailTitle": "Không copy được",
        "copyFailDesc": "Trình duyệt từ chối quyền truy cập clipboard."
      }
    }
  },
  "gmvReport": {
    "title": "Báo cáo GMV",
    "subtitle": "GMV theo seller / merchant / category / kỳ. Cache 5 phút (BE Redis).",
    "refresh": "Làm mới",
    "exportCsv": "Xuất CSV",
    "filtersAria": "Bộ lọc",
    "chartTitle": "GMV {{group}}",
    "noDataRange": "Chưa có dữ liệu trong khoảng thời gian này.",
    "noData": "Không có dữ liệu.",
    "filters": {
      "dateFrom": "Từ ngày",
      "dateTo": "Đến ngày",
      "groupBy": "Nhóm theo",
      "chart": "Biểu đồ"
    },
    "groupBy": {
      "saler": "Theo seller",
      "merchant": "Theo merchant",
      "category": "Theo category",
      "day": "Theo ngày",
      "month": "Theo tháng"
    },
    "chartType": {
      "bar": "Cột",
      "line": "Đường"
    },
    "kpi": {
      "gross": "Tổng GMV",
      "refunded": "Đã hoàn tiền",
      "net": "GMV thuần"
    },
    "table": {
      "orders": "Đơn hàng",
      "gross": "Tổng GMV",
      "refunded": "Đã hoàn tiền",
      "net": "GMV thuần"
    },
    "toast": {
      "exportSuccessTitle": "Đã tạo job export",
      "exportSuccessDesc": "Email sẽ gửi khi hoàn tất (~{{seconds}}s).",
      "exportFailTitle": "Không tạo được export"
    }
  },
  "leaderboard": {
    "title": "Bảng xếp hạng Seller",
    "subtitle": "Top {{topN}} seller theo GMV. Materialized view refresh mỗi 10 phút; Admin có thể force refresh (giới hạn 2 lần / 5 phút).",
    "refreshNow": "Làm mới ngay",
    "periodAria": "Chu kỳ",
    "podiumAria": "Top 3",
    "podiumEmpty": "Chưa có dữ liệu cho chu kỳ này.",
    "gmv": "GMV",
    "dealsWon": "Deal thắng",
    "period": {
      "month": "Tháng",
      "quarter": "Quý",
      "all_time": "Toàn thời gian"
    },
    "table": {
      "rank": "#",
      "saler": "Seller",
      "gmv": "GMV",
      "dealsWon": "Deal thắng",
      "empty": "Không có thêm seller ngoài podium."
    },
    "toast": {
      "refreshSuccessTitle": "Đã refresh leaderboard",
      "refreshSuccessDesc": "{{count}} hàng cập nhật.",
      "refreshFailTitle": "Không refresh được"
    }
  },
  "myPerformance": {
    "heading": "Hiệu suất của tôi",
    "subtitle": "Theo dõi GMV, mục tiêu và tỷ lệ chuyển đổi cá nhân theo từng chu kỳ.",
    "loadError": "Không tải được dữ liệu.",
    "periodAria": "Chu kỳ",
    "periods": {
      "monthly": "Tháng này",
      "quarterly": "Quý này",
      "semi": "Nửa năm",
      "annual": "Năm"
    },
    "kpiAria": "KPI",
    "kpi": {
      "targetGmv": "GMV mục tiêu",
      "currentGmv": "GMV hiện tại",
      "progress": "Tiến độ",
      "overallConversion": "Tỷ lệ chuyển đổi tổng"
    },
    "progress": {
      "aria": "Tiến độ vs mục tiêu",
      "title": "Tiến độ vs mục tiêu",
      "detail": "{{current}} / {{target}} (đến hết {{date}})",
      "empty": "Chưa có mục tiêu được cấu hình cho chu kỳ này."
    },
    "funnel": {
      "aria": "Phễu chuyển đổi",
      "title": "Phễu chuyển đổi",
      "empty": "Chưa có dữ liệu phễu cho chu kỳ này."
    }
  },
  "myProfile": {
    "loading": "Đang tải hồ sơ",
    "loadError": "Không thể tải hồ sơ.",
    "heading": "Hồ sơ cá nhân",
    "subtitle": "Thông tin liên hệ, chữ ký email và tuỳ chọn thông báo của bạn.",
    "validation": {
      "minChars": "Tối thiểu {{count}} ký tự",
      "maxChars": "Tối đa {{count}} ký tự",
      "invalidUrl": "Đường dẫn không hợp lệ"
    },
    "toast": {
      "savedTitle": "Đã lưu",
      "savedDesc": "Hồ sơ đã được cập nhật.",
      "saveFailTitle": "Không lưu được"
    },
    "basic": {
      "title": "Thông tin cơ bản",
      "emailLabel": "Email",
      "emailNote": "không thể đổi tại đây — liên hệ admin nếu cần.",
      "name": "Họ và tên",
      "phone": "Số điện thoại",
      "phonePlaceholder": "+84 ...",
      "avatarUrl": "Đường dẫn ảnh đại diện",
      "avatarHelp": "PNG/JPG, tối đa 2MB. Dùng FileUploadInput ở đợt sau; hiện tại dán URL trực tiếp.",
      "signatureLabel": "Chữ ký email (tối đa {{count}} ký tự)",
      "signatureHelpPrefix": "Dùng ",
      "signatureHelpSuffix": " để chèn tên người gửi tự động."
    },
    "notifications": {
      "title": "Tuỳ chọn thông báo",
      "desc": "Thay đổi áp dụng cho lần gửi kế tiếp.",
      "followUp": "Thông báo nhắc follow-up",
      "dealExpire": "Thông báo deal sắp hết hạn",
      "digestLabel": "Tóm tắt định kỳ",
      "digest": {
        "off": "Tắt",
        "daily": "Hàng ngày",
        "weekly": "Hàng tuần"
      }
    },
    "ics": {
      "title": "Lịch ICS",
      "desc": "Tạo lại URL lịch ICS khi nghi ngờ rò rỉ. URL cũ vẫn hoạt động trong 7 ngày sau khi tạo mới."
    },
    "save": {
      "saving": "Đang lưu…",
      "submit": "Lưu thay đổi"
    }
  },
  "overview": {
    "heading": "Tổng quan bán hàng",
    "subtitle": "Tổng quan leads, deals, mục tiêu và hoạt động hôm nay.",
    "loadError": "Không tải được dữ liệu.",
    "kpiAria": "KPI",
    "cards": {
      "leads-today": "Leads hôm nay",
      "deals-expiring": "Deals gần hết hạn",
      "target-progress": "Tiến độ mục tiêu tháng",
      "activity-today": "Hoạt động hôm nay"
    },
    "leaderboard": {
      "aria": "Bảng xếp hạng",
      "title": "Top 10 Salers",
      "periods": {
        "month": "Tháng",
        "quarter": "Quý",
        "all_time": "Toàn thời gian"
      },
      "columns": {
        "rank": "Hạng",
        "saler": "Saler",
        "gmv": "GMV",
        "dealsWon": "Deals đã chốt"
      },
      "empty": "Chưa có dữ liệu bảng xếp hạng."
    },
    "activity": {
      "aria": "Hoạt động",
      "label": "Hoạt động:",
      "loadError": "Không tải được dữ liệu hoạt động.",
      "title": "Hoạt động gần đây",
      "subtitle": "30 ngày gần đây — tối đa 50 sự kiện.",
      "empty": "Chưa có hoạt động nào."
    }
  },
  "targets": {
    "heading": "Seller KPI Targets",
    "subtitle": "Quản lý mục tiêu GMV theo chu kỳ — admin/manager có thể tạo mới + chỉnh sửa inline.",
    "exportCsv": "Xuất CSV",
    "newTarget": "Tạo mục tiêu mới",
    "periodAria": "Chu kỳ",
    "periods": {
      "all": "Tất cả",
      "monthly": "Tháng",
      "quarterly": "Quý",
      "semi": "Nửa năm",
      "annual": "Năm"
    },
    "columns": {
      "saler": "Seller",
      "period": "Chu kỳ",
      "range": "Khoảng thời gian",
      "targetGmv": "GMV mục tiêu",
      "current": "Hiện tại",
      "achieved": "% Đạt"
    },
    "empty": "Chưa có mục tiêu nào cho chu kỳ này.",
    "rowActions": {
      "cancel": "Hủy",
      "save": "Lưu",
      "edit": "Sửa"
    },
    "toast": {
      "createdTitle": "Đã tạo mục tiêu",
      "createdDesc": "KPI target được lưu thành công.",
      "createFailTitle": "Không tạo được mục tiêu",
      "updatedTitle": "Đã cập nhật mục tiêu",
      "updateFailTitle": "Không cập nhật được",
      "exportTitle": "Đã tạo job export",
      "exportDesc": "Email sẽ gửi khi hoàn tất (~{{eta}}s).",
      "exportFailTitle": "Không tạo được export",
      "invalidValueTitle": "Giá trị không hợp lệ",
      "invalidValueDesc": "Mục tiêu phải là số dương."
    },
    "modal": {
      "aria": "Tạo KPI target mới",
      "title": "Tạo KPI target",
      "salerLabel": "Seller",
      "salerPlaceholder": "Tìm seller theo tên / email…",
      "periodLabel": "Chu kỳ",
      "startLabel": "Bắt đầu",
      "endLabel": "Kết thúc",
      "gmvLabel": "GMV mục tiêu (USD)",
      "cancel": "Hủy",
      "create": "Tạo"
    }
  }
}
